import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../AuthContext";
import { getOpeningTimes, createOpeningTime, updateOpeningTime } from "../api";

const dayOrder = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
const dayLabels = {
    MONDAY: "Montag",
    TUESDAY: "Dienstag",
    WEDNESDAY: "Mittwoch",
    THURSDAY: "Donnerstag",
    FRIDAY: "Freitag",
    SATURDAY: "Samstag",
    SUNDAY: "Sonntag",
};

export default function OpeningTimes() {
    const { token } = useContext(AuthContext);
    const [times, setTimes] = useState([]);
    const [status, setStatus] = useState("");

    const load = async () => {
        try {
            const data = await getOpeningTimes();
            const merged = dayOrder.map(d => {
                const t = data.find(t => t.dayOfWeek === d);
                return t
                    ? {
                        ...t,
                        afternoonOpen: t.afternoonOpen || "",
                        afternoonClose: t.afternoonClose || "",
                    }
                    : { dayOfWeek: d, open: "", close: "", hasLunchBreak: false, afternoonOpen: "", afternoonClose: "" };
            });
            setTimes(merged);
        } catch (e) {
            setTimes(dayOrder.map(d => ({ dayOfWeek: d, open: "", close: "", hasLunchBreak: false, afternoonOpen: "", afternoonClose: "" })));
        }
    };

    useEffect(() => { load(); }, []);

    const handleChange = (idx, field, value) => {
        setTimes(prev => {
            const copy = [...prev];
            copy[idx] = { ...copy[idx], [field]: value };
            return copy;
        });
    };

    const save = async (t) => {
        try {
            const payload = {
                dayOfWeek: t.dayOfWeek,
                open: t.open,
                close: t.close,
                hasLunchBreak: t.hasLunchBreak,
            };
            if (t.hasLunchBreak) {
                payload.afternoonOpen = t.afternoonOpen;
                payload.afternoonClose = t.afternoonClose;
            }
            if (t.id) {
                await updateOpeningTime(token, t.id, payload);
            } else {
                const saved = await createOpeningTime(token, payload);
                t.id = saved.id;
            }
            setStatus("Gespeichert");
        } catch (e) {
            setStatus("Fehler beim Speichern");
        }
    };

    return (
        <div className="p-4 max-w-xl mx-auto">
            <h2 className="text-2xl mb-4">Öffnungszeiten</h2>
            {status && <p className="mb-2">{status}</p>}
            <table className="w-full border">
                <thead>
                    <tr className="bg-gray-100">
                        <th className="p-2 text-left">Tag</th>
                        <th className="p-2">Von</th>
                        <th className="p-2">Bis</th>
                        <th className="p-2">Mittagspause</th>
                        <th className="p-2">Von (nachmittags)</th>
                        <th className="p-2">Bis (nachmittags)</th>
                        <th className="p-2">Aktion</th>
                    </tr>
                </thead>
                <tbody>
                    {times.map((t, idx) => (
                        <tr key={t.dayOfWeek} className="border-t">
                            <td className="p-2">{dayLabels[t.dayOfWeek]}</td>
                            <td className="p-2">
                                <input
                                    type="time"
                                    value={t.open}
                                    onChange={e => handleChange(idx, "open", e.target.value)}
                                    className="border p-1"
                                />
                            </td>
                            <td className="p-2">
                                <input
                                    type="time"
                                    value={t.close}
                                    onChange={e => handleChange(idx, "close", e.target.value)}
                                    className="border p-1"
                                />
                            </td>
                            <td className="p-2 text-center">
                                <input
                                    type="checkbox"
                                    checked={t.hasLunchBreak || false}
                                    onChange={e => handleChange(idx, "hasLunchBreak", e.target.checked)}
                                />
                            </td>
                            <td className="p-2">
                                <input
                                    type="time"
                                    value={t.afternoonOpen || ""}
                                    onChange={e => handleChange(idx, "afternoonOpen", e.target.value)}
                                    className="border p-1"
                                    disabled={!t.hasLunchBreak}
                                />
                            </td>
                            <td className="p-2">
                                <input
                                    type="time"
                                    value={t.afternoonClose || ""}
                                    onChange={e => handleChange(idx, "afternoonClose", e.target.value)}
                                    className="border p-1"
                                    disabled={!t.hasLunchBreak}
                                />
                            </td>
                            <td className="p-2 text-center">
                                <button
                                    className="bg-blue-600 text-white px-2 py-1 rounded"
                                    onClick={() => save(t)}
                                >
                                    Speichern
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

